import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px = 'M3 10.43 8 5l5 5.42Z';
const draw24px = 'M7,14.42,12,9l5,5.42Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TriangleUpIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'triangleUp'),
) as IconWithRender;

TriangleUpIcon.displayName = 'TriangleUpIcon';
TriangleUpIcon.propTypes = Icon.propTypes;
TriangleUpIcon.renderIcon = (props) => <TriangleUpIcon {...props} />;
export default TriangleUpIcon;
